export enum EBuildingClass {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
}
